import styles from './index.module.css'

import React from 'react'

import Alert from 'components/ui/alert'
import InlineLink from 'components/ui/inline-link'

export const LibraryEasyAccessAlert: () => React.ReactElement<
  React.ComponentProps<'div'>,
  'div'
> = () => {
  return (
    <div className={styles.libraryAlert}>
      <Alert icon="info" status="info">
        Supervisors can now search your Easy Access Catalogs from their DISCO
        and stats will show here.
        <InlineLink
          to="https://support.disco.ac/home/catalogs-guide#enabling-easy-access-to-make-your-catalog-discoverable-by-music-supervisors-on-disco"
          rel="noopener noreferrer"
          target="_blank"
        >
          {' '}
          Find out more.
        </InlineLink>
      </Alert>
    </div>
  )
}
